import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, ViewEncapsulation, NgZone } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { WalletInfo } from 'src/app/core/models/wallet-info.model';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConvertTokensComponent } from '../convert-tokens/convert-tokens.component';
import { UserAccountDialog } from '../../event-navigation/pages/event-tickets/event-tickets.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { CONST_AWS_API, API, COUNTRIES_LIST } from '../../../../core/constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { API as AWS_API } from 'aws-amplify';
import { WalletConnectDialogComponent } from '../../wallet-connect-dialog/wallet-connect-dialog.component';
import { Web3Service } from 'src/app/core/services/web3.service';
import { CommunityTipsComponent } from '../../indigenous-cloud/community/community-tips/community-tips.component';
declare var Stripe: any;
declare var fbq: any;
var stripe;
var elements;
@Component({
  selector: 'app-payment-transactions',
  templateUrl: './payment-transactions.component.html',
  styleUrls: ['./payment-transactions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PaymentTransactionsComponent implements OnInit {
  isCryptoWallet = environment.clientDetails.required_crypto_wallet;
  Contracts_Rinkeby: any;
  selectedTransaction = ""
  selectedToken: string = '';
  copyData = "0x61924bk7134jf22b0549841a7aacab3c509b0281f";
  assets_url = environment.assets_url;
  transactionInfo: any;
  selectedCard: any = {};
  selectedCardInfoSubscr: Subscription;
  savedCardsListSubscr: Subscription;
  savedCardsList: any = [];
  addressList: any = [];
  addressListInfoSubscr: Subscription;
  selectedShippingAddress: any;
  selectedBillingAddress: any;
  addNewCard: boolean = false;
  streamInfo: any;
  streamInfoSubscr: Subscription;
  getCurrency: any;
  currencyInfoSubscription: Subscription;
  currentLocation: {};
  currentTheme: any;
  card: any;
  cardError: string;
  validStripeForm = false;
  redirectUrl = '';
  invoice_id: any;
  taxAmount = 0;
  taxable: boolean = true;
  save_card: boolean = false;
  userInfoSubscription: Subscription;
  userInfo: any;
  enableTransactions: boolean;
  getBillingValue: any;
  mobileUrl: string;
  cashWalletForm: FormGroup;
  totalAmount: any = 0;
  totalAmtSubscr: Subscription;
  currency_for_totAmt: any;
  formsValSubscr: Subscription;
  billingInfoSubscr: Subscription;
  userDetailSubscr: Subscription;
  userDetail: any;
  paymentType: any;
  performerInfoSubscr: Subscription;
  performerInfo: any;
  transactionInfoSubscr: Subscription;
  taxPercentage = 0;
  org_info: any;
  processingFee: number = 0;
  walletInfoSubscr: Subscription;
  wallet_pf: number = 0;
  amt_without_pf: number = 0;
  paymentBtnSubscr: Subscription;
  creatorCurrency: any;
  streamId: any;
  amount: number = 0;
  userCurrency: any;
  isMobile: boolean = false;
  isPaymentSuccess: boolean = false;
  channelUrl: String = '';
  walletID: string;
  available_balance: any = undefined;
  crypto_balance: Number;
  network_name: any;
  tokens: number;
  USD_Rates: any;
  clientDetails: any;
  cryptoToken: any;
  cryptoSymbol: any;
  cryptoAmount: any;
  cryptoForm: FormGroup;
  deviceInfo: string = 'web';
  crypto_pf: number = 0;
  channelName: any;
  chainNetwork: any;
  @Input() activeBlock;
  @Input() currentBlock;
  @Input() nftTickets;
  @Input() nftTicketPrice;
  @Input('settingsData') settingsData: any = {};
  @Input() nftDetails;
  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  @Output() getTransactionDetails = new EventEmitter<any>();
  accounchanged: Subscription;
  

  constructor(
    private toastr: ToastrService,
    private commonSubscribeService: CommanSubscribeService,
    private storageService: StorageService,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    private loader: NgxUiLoaderService,
    private appPaymentService: AppPaymentTVService,
    public router: Router,
    private web3service: Web3Service,
    private ngZone: NgZone,
    private formBuilder: FormBuilder,private dialogRef: MatDialogRef<CommunityTipsComponent>) {
    this.Contracts_Rinkeby = this.web3service.Contracts_Rinkeby;
  }


  async changeNetwork() {
    return new Promise((resolve) => {
      let chaindata = this.nftDetails.blockchain == 'Polygon' ? 'Polygon' : 'Sepolia';
      localStorage.setItem('networkId', chaindata);
      this.web3service.changeNetwork(chaindata).then(data => {
        this.web3service.setContract();
        resolve(chaindata)
      })
    })
  }
  async ngOnInit() {
    this.channelName = this.router.url.split("/")[1];
    this.isCryptoWallet === 1 && localStorage.setItem('networkId', environment.clientDetails.network.charAt(0).toUpperCase() + environment.clientDetails.network.slice(1));
    this.Contracts_Rinkeby = this.web3service.Contracts_Rinkeby;

    

    if (localStorage.getItem('WalletId') && localStorage.getItem('WalletId') != '' && this.isCryptoWallet === 1) {
      this.walletID = localStorage.getItem('WalletId');
      // this.web3service.intermidateConnect();
      this.web3service.setContract();
    } else {
      // this.isCryptoWallet === 1 && this.connectWallet();
    }
    // if (this.isCryptoWallet === 1) {
    //   this.web3service.getchainId().then(async (chainid: any) => {
    //     this.chainNetwork = chainid;
    //   })
    // }
    if (this.nftTickets && this.isCryptoWallet === 1) {
      if (this.nftDetails?.blockchain != this.chainNetwork) {
        await this.changeNetwork();
      }
    }
    this.network_name = environment.clientDetails.network_name;
    this.web3service.setNetwork(this.network_name);
    this.deviceInfo = this.commonSubscribeService.getMobileOperatingSystem();
    this.commonSubscribeService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;
    });
    this.ngZone.run(() => {
      if (this.isCryptoWallet === 1) {
        this.web3service.setContract();
        this.accounchanged = this.web3service.getchangeaccount().subscribe(data => {
          this.walletID = data;
          let erc20contract = this.web3service.getContract('ERC20');
          erc20contract.methods.balanceOf(this.walletID).call().then(resp => {
            let available_balance = Number(resp) / (10 ** 18)
            let crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
            this.available_balance = available_balance
            this.crypto_balance = crypto_balance
            if (this.available_balance < this.nftTicketPrice) {
              this.add_amt_to_crypto_wallet = true;
            }
            else {
              this.add_amt_to_crypto_wallet = true;
            }
          })
        });
      }
    })
    this.settingsData = this.settingsData;
    this.addStyle();
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;
    if (this.route.snapshot.params.token) {
      this.streamId = this.getParam('stream_id');
      this.amount = Number(this.getParam('amount'));
      this.userCurrency = this.getParam('currency');
      let data = {
        "total_amount": this.amount,
        "currency": this.userCurrency,
        "amt_without_pf": this.amount
      }
      this.finalVal = this.amount;
      this.commonSubscribeService.totalAmountSubject.next(data);
      if (this.router.url.includes('/vod-tip-donation-payment/')) {
        this.isMobile = true;
        this.enableTransactions = true;
        this.activeBlock = this.router.url.includes('/vod-tip-donation-payment/performer_tip') ? "Tips" : "Donations";
      }
      if (this.router.url.includes('/community-tip-donation-payment/')) {
        this.isMobile = true;
        this.enableTransactions = true;
        this.activeBlock = this.router.url.includes('/community-tip-donation-payment/community_tip') ? "Tips" : "Donations";
      }

    }
    this.walletInfoSubscr = this.commonSubscribeService.updateAvailBal().subscribe(response => {
      if (response) {
        this.appPaymentService.getRequestWithParams(API.GET_WALLET, { organization_id: String(this.walletOrgId || '') }).subscribe(response => {
          if (response.status == 0) {
            this.walletInfo = response.wallet;
            this.commonSubscribeService.walletByOrg[this.walletOrgId] = response.wallet;
            this.commonSubscribeService.walletInfoSubject.next({ organizationId: this.walletOrgId, wallet: response.wallet });
          }
        }, error => {
          this.toastr.error(error.error);
        });
      }
    })
    this.formsValSubscr = this.commonSubscribeService.getFormsValidationVal().subscribe(response => {
      console.log(response, "Form Validation Response");
      if (response) {
        console.log("Form Validation Response False");
        this.enableTransactions = true;
        this.isPayment = false
      } else {
        console.log("Form Validation Response False");
        this.enableTransactions = false;
        this.isPayment = true
      }

    });

    this.billingInfoSubscr = this.commonSubscribeService.getBillingInfo().subscribe(response => {
      this.getBillingValue = response;
      if (this.currentBlock == "Merchandise" || this.currentBlock == "Subscribe" || this.currentBlock == "Tickets" || this.currentBlock == "PPV" || this.currentBlock == "Merch Market") {
        this.selectedTransaction = "";
      }
    })

    this.totalAmtSubscr = this.commonSubscribeService.getTotalAmount().subscribe(response => {
      this.totalAmount = isNaN(response.total_amount) ? 0 : response.total_amount;
      this.totalAmount = Number(this.totalAmount);
      this.currency_for_totAmt = response.currency;
      this.amt_without_pf = this.nftTickets ? this.nftTicketPrice : response.amt_without_pf;
      this.finalVal = this.totalAmount;
      this.processingFee = response.processing_fee;
      if (this.selectedTransaction == "wallet") {
        this.evaluateWalletSufficiency();
      }
      if (this.selectedTransaction == "crypto") {
        if (this.amt_without_pf) {
          this.calDiffAmt();
        }
      }
    })

    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      if (!this.userInfo.is_guest && this.userInfo.id) {
        this.getAvailBalance();
      }
      if (this.userInfo && this.userInfo.is_guest) {
        this.save_card = false;
        this.addNewCard = true;
      } else if (this.userInfo.id && !this.userInfo.is_guest) {
        this.save_card = true;
      }
    });

    if (this.router.url.includes('/vod-tip-donation-payment/') || this.router.url.includes('/community-tip-donation-payment/')) {
      this.getUserInfo(() => {
        this.getAvailBalance();
        this.getStreamInfo();
      });
    }

    this.userDetailSubscr = this.commonSubscribeService.getUserDetail().subscribe(response => {
      this.userDetail = response;
      if (response.close_modal) {
        this.selectedTransaction = "";
      }
    });

    this.paymentBtnSubscr = this.commonSubscribeService.updatePaymentBtn().subscribe(response => {
      if (response == true) {
        this.isPayment = false;
      }
    });

    if (!this.userInfo.is_guest && this.userInfo.id) {
      this.getAvailBalance();
    }

    if (this.userInfo.is_guest) {
      this.addNewCard = true;
    }

    if (this.route.snapshot.queryParams.user_id) {
      this.mobileUrl = environment.CONSUMER_PORTAL + this.route.snapshot.params.slug_name + '/cancel-payment';
    }

    if (this.userInfo.id && !this.userInfo.is_guest) {
      this.save_card = true;
    }

    this.getCurrency = this.storageService.getItem('currency');
    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
      }
    });

    this.performerInfo = this.commonSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      if (response && response.data && response.data.Data && response.data.Data[0] && response.data.Data[0].performer_details) {
        this.performerInfo = response.data.Data[0].performer_details;
      }
      if (response && response.data && response.data.Data && response.data.Data[0] && response.data.Data[0].org_info) {
        this.org_info = response.data.Data[0].org_info;
      }
    });
    if (this.router.url.includes("/subscription-list")) {
      if (this.performerInfo && this.performerInfo["data"] && this.performerInfo["data"]["Data"] && this.performerInfo["data"]["Data"].length > 0) {
        let pInfo = this.performerInfo["data"]["Data"][0];
        if (pInfo.performer_details) {
          this.performerInfo = pInfo.performer_details;
        }
        if (pInfo.org_info) {
          this.org_info = pInfo.org_info;
        }
        if (pInfo && pInfo.plans && pInfo.plans.length > 0) {
          this.creatorCurrency = pInfo["plans"][0].currency_type;
        }
      }
    }

     if(this.router.url.includes('/community-tip-donation-payment/')){
         console.log("inside condition router url : ", this.router.url);
         const queryParams = new URLSearchParams(window.location.search);
          const networkName = queryParams.get('network_name');
          const spaceId = queryParams.get('space_id');
          const communityTipMessage = queryParams.get('message');
          this.channelUrl = `${environment.CONSUMER_PORTAL}${networkName}/community/${spaceId}?communityTipMessage=${encodeURIComponent(communityTipMessage)}`;
          console.log("channel url : ", this.channelUrl);
    }

    this.currentTheme = this.commonSubscribeService.getThemeColors();
    let resp = this.commonSubscribeService.slugInfo;
    this.streamInfo = resp && resp.stream_info ? resp.stream_info : resp;
    if (!this.userInfo.is_guest && this.userInfo.id) {
      this.getAvailBalance();
    }
    this.streamInfoSubscr = this.commonSubscribeService.getSlugData().subscribe(response => {
      this.streamInfo = response.stream_info ? response.stream_info : response;
      if (!this.userInfo.is_guest && this.userInfo.id) {
        // streamInfo (and its organization_id) is only known from here on — re-fetch the
        // wallet balance now, since any earlier fetch in ngOnInit ran before this was set
        // and would have resolved to the wrong (default) organization's balance.
        this.getAvailBalance();
      }
      if (this.streamInfo && this.streamInfo.currency_type) {
        // let creatorCur = this.getCurrency == "GBP" ? "GBP" : "USD";
        // this.loadStripe(this.getCurrency, this.streamInfo.currency_type);
        this.getCurrencyRates();
      }
    });

    
    this.creatorCurrency = this.creatorCurrency ? this.creatorCurrency : 'USD';
    if ((this.streamInfo && this.streamInfo.currency_type) || this.creatorCurrency) {
      // this.loadStripe(this.getCurrency, this.streamInfo.currency_type);
      this.getCurrencyRates();
    }

    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : {};
          this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
        } else {
          this.currentLocation = json;
        }
      });
    }
    if (this.currentLocation && Object.keys(this.currentLocation).length > 0)
      this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
    this.savedCardsListSubscr = this.commonSubscribeService.getSavedCards().subscribe(response => {
      this.savedCardsList = response;
      if (this.savedCardsList.length == 0 && (this.selectedTransaction == 'ott' || (this.selectedTransaction == 'crypto' && this.crypto_amt > this.available_balance && this.available_balance != undefined) || (this.selectedTransaction == 'wallet' && (this.walletInfo && this.walletInfo.amount < this.finalVal) || (this.walletInfo && this.walletInfo.amount < 0) || Object.keys(this.walletInfo).length == 0))) {
        this.addNewCard = true;
        if (this.savedCardsList.length == 0) {
          setTimeout(() => {
            this.initiateCardElement();
          }, 1000);
        }

      }
    });

    this.selectedCardInfoSubscr = this.commonSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
      if (response) {
        this.addNewCard = false;
        this.newCardForCrypto = false;
        this.selectedBillingAddress = {};
        if (this.selectedCard && this.selectedCard.id) {
          let card = this.selectedCard.billing_address;
          this.selectedBillingAddress.line1 = card.line1;
          this.selectedBillingAddress.line2 = card.line2;
          this.selectedBillingAddress.city = card.city;
          this.selectedBillingAddress.country = card.country;
          this.selectedBillingAddress.state = card.state;
          this.selectedBillingAddress.zip = card.postal_code;
        }
      }
    });

    this.addressListInfoSubscr = this.commonSubscribeService.getAddressList().subscribe(response => {
      this.addressList = response;
      if (this.addressList.billingAddress.length > 0) {
        let selectedAddress = this.addressList.billingAddress.filter(a => a.defaultBillingAddress);
        this.selectedBillingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
      }
    });

    this.cashWalletForm = this.formBuilder.group({
      amount: ['', Validators.required]
    });

    this.cryptoForm = this.formBuilder.group({
      crypto_amount: ['', Validators.required]
    });


    this.transactionInfoSubscr = this.commonSubscribeService.getTransactionInfo().subscribe(response => {
      if (((this.router.url.includes('/album/video') || this.router.url.includes('album/audio')) && (this.activeBlock == 'Tips' || this.activeBlock == 'Donations')) || this.router.url.includes('/vod-tip-donation-payment/performer_tip') || this.router.url.includes('/vod-tip-donation-payment/charity_donation') || this.router.url.includes('/community-tip-donation-payment/community_tip')) {
        this.transactionInfo = response;
        this.card = this.transactionInfo["card"];
        // Validate that the selectedCard actually belongs to the current user's saved cards
        // to prevent using a stale card from a previous session that belongs to a different Stripe customer
        const isValidSavedCard = this.selectedCard && this.selectedCard.id &&
          this.savedCardsList.some((card: any) => card.id === this.selectedCard.id);
        if (isValidSavedCard) {
          this.makePayment('card');
        } else {
          this.selectedCard = {};
          this.makePayment();
        }
      }
    })

    if (this.nftTickets && this.currentBlock == "Tickets") {
      this.selectedTransaction = 'crypto';
      this.add_amt_to_crypto_wallet = false;
      this.isPayment = true;
      if (this.walletID) {
        this.metamaskinstalled = true;
        let erc20contract = this.web3service.getContract('ERC20');
        erc20contract.methods.balanceOf(this.walletID).call().then(resp => {
          let available_balance = Number(resp) / (10 ** 18)
          let crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
          this.available_balance = available_balance
          this.crypto_balance = crypto_balance
          if (this.available_balance < this.nftTicketPrice) {
            this.add_amt_to_crypto_wallet = true;
            this.crypto_difference_amt = this.nftTicketPrice - this.available_balance;
            console.log(this.crypto_difference_amt, "cryptowallet")
            this.sliced_crypto_diff_amt = Math.trunc(this.crypto_difference_amt * Math.pow(10, 3)) / Math.pow(10, 3);
            this.cryptoForm.patchValue({
              crypto_amount: this.crypto_difference_amt
            });
            this.cryptoPF()
            let creatorCur = this.getCurrency == "GBP" ? "GBP" : this.streamInfo.currency_type;
            this.loadStripe(this.getCurrency, creatorCur);
            this.addNewCard = true;
            if (this.savedCardsList.length == 0) {
              setTimeout(() => {
                this.initiateCardElement();
              }, 1000);
            }
            else if (this.savedCardsList.length > 0) {
              this.addNewCard = false;
            }
          }
          else {
            this.add_amt_to_crypto_wallet = false;
          }
        })
      }
    }
  }

  

  addStyle() {
    // const borderColor = this.settingsData?.font_tertiary_color;
    // document.documentElement.style.setProperty('--radio-label-color', borderColor);

    const dynamicColor = this.settingsData?.font_tertiary_color;
    document.documentElement.style.setProperty('--invalid-border-color', dynamicColor);
    document.documentElement.style.setProperty('--before-border-color', dynamicColor);

    const bgColor = this.settingsData?.bg_tertiary_color;
    const textColor = this.settingsData?.font_tertiary_color;

    document.documentElement.style.setProperty('--select-panel-text-color', textColor);

  }

  onTokenSelect(token: string) {
    const getGFLBalance = async () => {
      const gflContract = this.web3service.getContract('ERC20');
      return Number(await gflContract.methods.balanceOf(this.walletID).call()) / (10 ** 18);
    };

    const getKPBalance = async () => {
      const kpContract = this.web3service.getContract('ERC20_Kombat');
      return Number(await kpContract.methods.balanceOf(this.walletID).call()) / (10 ** 18);
    };

    Promise.all([getGFLBalance(), getKPBalance()]).then(([gflBalance, kpBalance]) => {
      if (token === 'GFL') {
        this.available_balance = gflBalance;
        this.crypto_balance = Math.trunc(gflBalance * Math.pow(10, 3)) / Math.pow(10, 3);
      } else {
        this.available_balance = kpBalance;
        this.crypto_balance = Math.trunc(kpBalance * Math.pow(10, 3)) / Math.pow(10, 3);
      }
      this.add_amt_to_crypto_wallet = this.available_balance < this.crypto_amt;
      this.cryptoForm.patchValue({
        crypto_amount: this.add_amt_to_crypto_wallet ? this.crypto_amt : 0
      });
      if (token === 'GFL') {
        this.isRunningOutOfTokens = gflBalance < this.crypto_amt;
      } else {
        this.isRunningOutOfTokens = kpBalance < this.crypto_amt;
      }
      (!this.isRunningOutOfTokens && !this.add_amt_to_crypto_wallet) && (this.isPayment = false);
      this.selectedToken = token;
    }).catch(error => {
      console.error('Error fetching token balances:', error);
      this.isRunningOutOfTokens = false;
    });
  }

  getCryptoAccountBalance(callback) {
    this.cryptoAmount = this.commonSubscribeService.getCryptoBalance().subscribe((result) => {
      this.available_balance = result.available_balance;
      this.available_balance > 0 ? this.crypto_balance = result.crypto_balance : this.crypto_balance = 0.00;
      this.calDiffAmt();
      callback();
    })
  }
  rates: any;
  minReqAmt: number = 0;

  getCurrencyRates() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let creatorCur = this.streamInfo && this.streamInfo.currency_type ? this.streamInfo.currency_type : this.creatorCurrency;
    let currency = this.getCurrency == "USD" || this.getCurrency == "GBP" ? this.getCurrency : creatorCur;
    let url = CONST_AWS_API.GET_EXCHANGE_RATES + '/' + currency;
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.rates = response['data']['Data']['rates'];
      }
    }).catch(error => {
    });
  }

  finalVal: any;
  convRate: any;
  getvalue(event, value?) {
    console.log(event, "Selected Payment Method");
    this.userInfo = this.commonSubscribeService.userInfo;
    this.commonSubscribeService.selectedCardSubject.next('');
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    if (event.value === 'ott') {
      (window as any).umami?.track(`Payment Selected - OTT by ${userId}`);
      const data = {
        actionType: "network",
        metaData: {
          title: "Payment Selected - OTT",
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo?.organization_id || null,
        networkGroupId : this.streamInfo?.network_group_id || null,

        clickAction:'album-payment'
      }
      this.commonSubscribeService.sendTriggeredEvent(data);
    }else if (event.value === 'wallet') {
      (window as any).umami?.track(`Payment Selected - Cash by ${userId}`);
      const data = {
        actionType: "network",
        metaData: {
          title: "Payment Selected - Cash",
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo?.organization_id || null,
        networkGroupId : this.streamInfo?.network_group_id || null,
        clickAction:'album-payment'
      }
      this.commonSubscribeService.sendTriggeredEvent(data);
    } else if(event.value === 'crypto'){
      (window as any).umami?.track(`Payment Selected - Crypto by ${userId}`);
      const data = {
        actionType: "network",
        metaData: {
          title: "Payment Selected - Crypto",
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo?.organization_id || null,
        networkGroupId : this.streamInfo?.network_group_id || null,

        clickAction:'album-payment'
      }
      this.commonSubscribeService.sendTriggeredEvent(data);
    }

    if (event == '')
      event.value = value;
    this.add_amt_to_wallet = false;
    this.isPayment = false;
    this.cardError = "";
    if ((Object.keys(this.userInfo)?.length == 0 || !this.userInfo.id || this.userInfo.is_guest) && (event.value == 'wallet')) {
      if (Object.keys(this.userInfo)?.length == 0 || !this.userInfo.id || (this.userInfo && this.userInfo.is_guest)) {
        this.userInfo.deviceInfo = this.deviceInfo
        this.userDetail.deviceInfo = this.deviceInfo
        // Without this, the post-signup verification step (consumer-verification-code.component.ts)
        // finds no skipRedirection flag and falls through to its own event-access redirect logic,
        // sending the buyer to watch/schedule instead of back here to finish this in-progress order
        // (e.g. an add-on ticket purchase) - matching the flag already set before every other
        // UserAccountDialog/ConsumerSignInComponent open in the checkout flow (event-tickets.component.ts).
        this.storageService.setItem('skipRedirection', 'yes');
        const dialogRef = this.dialog.open(UserAccountDialog, {
          panelClass: 'app-signout-confirmation',
          disableClose: true,
          data: this.userInfo ? this.userInfo : this.userDetail
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result == 'no') {
            this.selectedTransaction = '';
          }
        });
      }
      return;
    }
    this.selectedTransaction = event.value;
    if (event.value == 'ott' || event.value == 'crypto') {
      this.dispSavedCards = true;
      let creatorCur = this.router.url.includes("/subscription-list") ? this.creatorCurrency : this.streamInfo?.currency_type ? this.streamInfo?.currency_type : this.creatorCurrency;
      this.loadStripe(this.getCurrency, creatorCur);
    }
    this.userInfo.selectedTransaction = this.selectedTransaction;
    this.commonSubscribeService.updatePaymentBtnSubject.next(event.value);
    this.getTransactionDetails.emit(this.userInfo);
    let firstConVal, conVal = 0;
    this.dispSavedCards = false;
    this.totalAmount = Number((this.totalAmount).toFixed(2))
    this.finalVal = Number((this.totalAmount).toFixed(2));
    if (this.selectedTransaction == 'ott' || this.selectedTransaction == 'wallet')
      this.addNewCard = this.savedCardsList.length > 0 ? false : (this.walletInfo && this.walletInfo.amount < this.finalVal) || event.value == "ott" ? true : false;
    this.userInfo.difference_amt = 0;
    if (this.selectedTransaction == 'wallet') {
      let userCur = this.walletInfo.currency ? this.walletInfo.currency : this.getCurrency;
      let creatorCur = userCur == "GBP" ? "GBP" : "USD";

      this.loadStripe(userCur, creatorCur);

      console.log(this.walletInfo, this.walletInfo.amount, this.walletInfo.currency, this.currency_for_totAmt, ":::::::>::::>>>:::::::")
      if ((this.walletInfo && this.walletInfo.amount <= 0 && this.walletInfo.currency == this.currency_for_totAmt) || Object.keys(this.walletInfo).length == 0) {
        this.dispSavedCards = this.add_amt_to_wallet = true;
        this.minAmount = this.totalAmount;
        // setTimeout(() => {
        this.cashWalletForm.patchValue({
          amount: Number(this.totalAmount.toFixed(2))
        });
        this.wallet_pf = (Number(this.cashInfo.amount) * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.wallet_pf = Number(this.wallet_pf.toFixed(2));
        this.finalVal = this.finalVal + this.wallet_pf;
        return;
        // }, 1000);
      }
      if (this.walletInfo.currency != this.currency_for_totAmt) {
        let firstConvRate, secConvRate;
        firstConvRate = this.rates[this.currency_for_totAmt];
        firstConVal = this.totalAmount / firstConvRate;
        secConvRate = this.rates[this.walletInfo.currency];
        this.convRate = (firstConvRate / secConvRate) * 1.025;
        this.convRate = Number((this.convRate).toFixed(2));
        conVal = firstConVal * secConvRate;
        this.finalVal = this.amt_without_pf = firstConVal * secConvRate * 1.025;
      } else if (this.walletInfo.currency == this.currency_for_totAmt) {
        this.finalVal = Number((this.totalAmount).toFixed(2));
      }
      this.finalVal = Number(this.finalVal.toFixed(2));
      let val = 0;
      if (this.walletInfo.amount > this.finalVal) {
        this.wallet_pf = 0;
        return;
      } else if (this.walletInfo.amount < this.finalVal) {
        this.minAmount = this.finalVal - this.walletInfo.amount;
        this.minAmount = Number((this.minAmount).toFixed(2));
        this.minReqAmt = this.walletInfo && this.walletInfo.currency ? Number(this.rates[this.walletInfo.currency].toFixed(2)) : Number(this.rates[this.getCurrency]);
        val = this.minAmount < this.minReqAmt ? this.minReqAmt : this.minAmount;
        conVal = conVal ? conVal - this.walletInfo.amount : 0;
        this.cashWalletForm.patchValue({
          amount: Number(val.toFixed(2))
        });
        this.wallet_pf = (Number(conVal ? conVal : val) * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.wallet_pf = Number(this.wallet_pf.toFixed(2));
        this.dispSavedCards = this.add_amt_to_wallet = true;
        let amt = this.minAmount < this.minReqAmt ? this.minReqAmt - this.minAmount : 0;
        this.finalVal = this.finalVal + this.wallet_pf + amt;
      }
    }
    if (event.value == "crypto") {
      console.log("wallet id", this.walletID);
      if (this.walletID == undefined || this.walletID == "" || this.walletID == null) {
        this.connectWallet();
        this.web3service.intermidateConnect();
      }
      this.web3service.getchainId().then(async (chainid: any) => {
        this.chainNetwork = chainid;
      })
      if (this.walletID) {
        this.metamaskinstalled = true;
        this.commonSubscribeService.getAccountBalance(this.walletID);
        this.cryptoAmount = this.commonSubscribeService.getCryptoBalance().subscribe((result) => {
          this.available_balance = result.available_balance;
          this.available_balance > 0 ? this.crypto_balance = result.crypto_balance : this.crypto_balance = 0.00;
          this.calDiffAmt();
        })
      }
    }
    if (this.router.url.includes('/vod-tip-donation-payment/') || this.router.url.includes('/community-tip-donation-payment/')) {
      this.calPF();
    }
    this.finalVal = Number((this.finalVal).toFixed(2));
    console.log("metamask installed", this.metamaskinstalled, this.walletID);
  }

  crypto_amt = 0;
  sliced_crypto_amt = 0;
  sliced_crypto_diff_amt = 0;
  crypto_amt_in_user_cur = 0;
  crypto_difference_amt = 0;
  isRunningOutOfTokens: boolean = false;

  calDiffAmt() {
    this.crypto_amt = this.commonSubscribeService.convertToCryptoAmount(this.amt_without_pf, this.USD_Rates[this.currency_for_totAmt]);
    this.sliced_crypto_amt = Math.trunc(this.crypto_amt * Math.pow(10, 3)) / Math.pow(10, 3);
    this.addNewCard = false;
    this.isPayment = false;
    this.isRunningOutOfTokens = false;
    if (this.available_balance < this.crypto_amt) {
      this.addNewCard = true
      this.add_amt_to_crypto_wallet = true;
      this.isPayment = true;
      this.isRunningOutOfTokens = true;
      this.crypto_difference_amt = this.crypto_amt - this.available_balance;
      this.sliced_crypto_diff_amt = Math.trunc(this.crypto_difference_amt * Math.pow(10, 3)) / Math.pow(10, 3);
      this.cryptoForm.patchValue({
        crypto_amount: this.crypto_difference_amt
      });
      this.crypto_amt_in_user_cur = this.commonSubscribeService.cryptoFiatConversion(this.crypto_difference_amt, this.USD_Rates[this.currency_for_totAmt]);
      this.cryptoPF()
      if (this.savedCardsList.length == 0) {
        setTimeout(() => {
          this.initiateCardElement();
        }, 1000);
      }
      else if (this.savedCardsList.length > 0) {
        this.addNewCard = false;
      }
    }
  }
  cryptoPF() {
    this.commonSubscribeService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;
      this.crypto_pf = 0;
      let user_fiat_curr = this.commonSubscribeService.cryptoFiatConversion(this.cryptoInfo.crypto_amount, this.USD_Rates[this.getCurrency]);
      this.crypto_amt_in_user_cur = this.commonSubscribeService.cryptoFiatConversion(this.cryptoInfo.crypto_amount, this.USD_Rates[this.getCurrency]);
      this.crypto_pf = (user_fiat_curr * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.crypto_pf = Number(this.crypto_pf.toFixed(2));
    });
  }
  calPF() {
    let finalAmt = 0;
    if (this.selectedTransaction == "wallet") {
      this.processingFee = 0;
      finalAmt = this.amount;
    } else if (this.selectedTransaction && this.selectedTransaction == "ott") {
      this.processingFee = 0;
      this.processingFee = (this.amount * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.processingFee = Number(this.processingFee.toFixed(2));
      finalAmt = Number(this.amount) + this.processingFee;
    }
    let data = {
      "total_amount": finalAmt,
      "currency": this.userCurrency,
      "processing_fee": this.processingFee ? this.processingFee : undefined,
      "amt_without_pf": Number(this.amount)
    }
    this.commonSubscribeService.totalAmountSubject.next(data);
  }

  copywalletvalue() {
    var el1 = document.createElement('input')
    el1.value = this.walletID;
    document.body.appendChild(el1);
    el1.select();
    document.execCommand('copy');
    this.toastr.success(el1.value + " " + "Copied..!")
    document.body.removeChild(el1);
  }

  dispSavedCards: boolean = false;
  add_amt_to_wallet: boolean = false;
  addFunds() {
    this.cardError = "";
    this.minAmount = this.rates[this.walletInfo.currency];
    this.minAmount = Number(this.minAmount.toFixed(2));
    this.add_amt_to_wallet = true;
    this.dispSavedCards = true;
    this.validStripeForm = false;
    this.cashWalletForm.patchValue({
      amount: ''
    });
    if (this.savedCardsList.length == 0) {
      this.addNewCard = true;
      setTimeout(() => {
        this.initiateCardElement();
      }, 1000);
    }
  }


  async onNFTTicketBuy() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
     const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Purchasing album ${albumId} - ${userId}`);
    const data = {
        actionType: "network",
        metaData: {
          title: `Purchasing album ${albumId}`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo?.organization_id || null,
        networkGroupId : this.streamInfo?.network_group_id || null,

        clickAction:'album-payment'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    
    if (this.available_balance < this.nftTicketPrice) {
      this.toastr.error("Insufficient Funds")
      return
    }
    let amount2 = this.web3service.convertPriceToEther(this.nftTicketPrice)
    let tokenId = this.nftDetails.tokenId.split('_')[1];
    let erc20contract = this.web3service.getContract('ERC20');
    this.loader.start();
    await this.web3service.getchainId().then((chainid) => {
      this.Contracts_Rinkeby = this.web3service.Contracts_Rinkeby
      if (chainid == this.nftDetails.blockchain) {
        erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_1155_ADDRESS, amount2).send({ from: this.walletID })
          .then(response => {
            this.web3service.sendnftstep({ payStep: 2, type: 'instant' });
            let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155');
            marketplacecontract_1155.methods.getFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, tokenId, Number(this.nftDetails.saleId))
              .call().then(Response => {
                marketplacecontract_1155.methods.buyFromFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, tokenId, amount2,
                  Number(this.nftDetails.saleId), 1, "0x00")
                  .send({ from: this.walletID })
                  .once('receipt', (receipt) => {
                    if (receipt.status == true) {
                      this.toastr.success("NFT ticket purchased successfully")
                      this.transactionInfo = {
                        "mode": this.selectedTransaction,
                        "currency": environment.clientDetails.crypto_token,
                        "crypto_wallet_id": this.walletID,
                        "transaction_amount": Number(this.nftTicketPrice / environment.ONE_USD),
                        "token_id": this.nftDetails ? this.nftDetails.tokenId : undefined
                      }
                      this.commonSubscribeService.sendTransactionInfo(this.transactionInfo);
                    }
                    else {
                      this.toastr.error("Transaction Failed")
                    }
                    this.loader.stop();
                    // this.dataOfBuyNft();
                  })
                  .catch(e => {
                    if (e.message.includes('User denied transaction signature')) {
                      this.toastr.error('Transaction Rejected.');
                    }
                    this.loader.stop();
                    console.log(e)
                  })
              })
          })
          .catch(e => {
            if (e.message.includes('User denied transaction signature')) {
              this.toastr.error('Transaction Rejected.');
            }
            this.loader.stop();
            console.log(e)
          })
      }
      else {
        let chaindata = this.nftDetails.blockchain == 'Polygon' ? 'Polygon' : 'Sepolia';
        localStorage.setItem('networkId', chaindata);
        this.web3service.changeNetwork(chaindata).then(data => {
          if (!data || data == null) {
            erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_1155_ADDRESS, amount2).send({ from: this.walletID })
              .then(response => {
                this.web3service.sendnftstep({ payStep: 2, type: 'instant' });
                let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155');
                marketplacecontract_1155.methods.getFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, tokenId, Number(this.nftDetails.saleId))
                  .call().then(Response => {
                    marketplacecontract_1155.methods.buyFromFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, tokenId, amount2,
                      Number(this.nftDetails.saleId), 1, "0x00")
                      .send({ from: this.walletID })
                      .once('receipt', (receipt) => {
                        if (receipt.status == true) {
                          this.toastr.success("NFT ticket purchased successfully")
                          this.transactionInfo = {
                            "mode": this.selectedTransaction,
                            "currency": environment.clientDetails.crypto_token,
                            "crypto_wallet_id": this.walletID,
                            "transaction_amount": Number(this.nftTicketPrice),
                            "token_id": this.nftDetails ? this.nftDetails.tokenId : undefined
                          }
                          this.commonSubscribeService.sendTransactionInfo(this.transactionInfo);
                        }
                        else {
                          this.toastr.error("Transaction Failed")
                        }
                        this.loader.stop();
                        // this.dataOfBuyNft();
                      })
                      .catch(e => {
                        if (e.message.includes('User denied transaction signature')) {
                          this.toastr.error('Transaction Rejected.');
                        }
                        this.loader.stop();
                        console.log(e)
                      })
                  })
              })
              .catch(e => {
                if (e.message.includes('User denied transaction signature')) {
                  this.toastr.error('Transaction Rejected.');
                }
                this.loader.stop();
                console.log(e)
              })
          }
        })
      }
    })
  }

  connectWallet() {
    console.log("connect wallet");
    this.web3service.checkAndInstantiateWeb3().then(isweb3 => {
      console.log("isweb3", isweb3);
      if (isweb3 === 'connected') {
        this.metamaskinstalled = true;
        this.web3service.connectAccount().then((response) => {
          console.log("response", response);
          if (response == undefined)
            return
          this.web3service.setContract();
          let erc20contract = this.web3service.getContract('ERC20');
          this.walletID = response;
          try {
            erc20contract.methods.balanceOf(this.walletID).call().then(resp => {
              let available_balance = Number(resp) / (10 ** 18)
              let crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
              this.available_balance = available_balance
              this.crypto_balance = crypto_balance
            })
          } catch (e: any) {
            console.log("error while fetching balance", e);
          }
        })
      }
    })
      .catch((e) => {
        this.metamaskinstalled = false;
        this.toastr.error(e);
        this.toastr.error(e);
        this.dialog.open(WalletConnectDialogComponent, {
          // backdropClass:'blurred',
          // disableClose: true,
          panelClass: "app-consumer-sign-in",
          hasBackdrop: true
        });
      })

  }
  newCardForCrypto = false;
  addCardForCrypto() {
    if (this.nftTickets) {
      let creatorCur = this.getCurrency == "GBP" ? "GBP" : "USD";
      this.loadStripe(this.getCurrency, creatorCur);
    }
    this.cardError = "";
    this.add_amt_to_crypto_wallet = true;
    this.selectedCard = {};
    this.validStripeForm = false;
    this.commonSubscribeService.selectedCardSubject.next(false);
    // if(this.savedCardsList.length == 0){
    this.newCardForCrypto = true;
    this.addNewCard = true;
    setTimeout(() => {
      this.initiateCardElement();
    }, 1000);
    // }
  }

  newCard() {
    this.cardError = "";
    this.addNewCard = true;
    this.selectedCard = {};
    this.validStripeForm = false;
    this.commonSubscribeService.selectedCardSubject.next(false);
    setTimeout(() => {
      this.initiateCardElement();
    }, 1000);
  }

  saveCard(event) {
    if (event.checked) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Saved Card Suucessfully - ${userId}`);
      const data = {
        actionType: "purchase",
        metaData: {
          title: "Saved Card Suucessfully",
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo?.organization_id || null,
        networkGroupId : this.streamInfo?.network_group_id || null,

      }
      this.commonSubscribeService.sendTriggeredEvent(data);
      this.save_card = true;
      if (!this.userInfo.id || (this.userInfo && this.userInfo.is_guest)) {
        this.userInfo.deviceInfo = this.deviceInfo
        const dialogRef = this.dialog.open(UserAccountDialog, {
          panelClass: 'app-signout-confirmation',
          disableClose: true,
          data: this.userInfo
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result == 'no') {
            this.save_card = false;
          }
        });
      }
    } else {
      this.save_card = false;
    }
  }

  get cashInfo() {
    return this.cashWalletForm.getRawValue();;
  }

  get cryptoInfo() {
    return this.cryptoForm.getRawValue();
  }

  minAmount: any;
  onAmountChange(value) {
    let firstConVal, conVal = 0, noCov = 0;
    let amt = this.minAmount < this.minReqAmt ? this.minReqAmt - this.minAmount : 0;
    let val = this.minAmount < this.minReqAmt ? this.minReqAmt : this.minAmount;
    if (value != "" && Number(value) < Number(val)) {
      this.cashWalletForm.patchValue({
        amount: Number(val.toFixed(2))
      });
      this.toastr.error('Minimum required amount is ' + Number(val).toFixed(2));
    }
    if (this.walletInfo.currency != this.currency_for_totAmt) {
      let firstConvRate, secConvRate;
      firstConvRate = this.rates[this.currency_for_totAmt];
      firstConVal = this.amt_without_pf / firstConvRate;
      secConvRate = this.rates[this.walletInfo.currency];
      this.convRate = firstConvRate * secConvRate * 1.025;
      this.convRate = Number((this.convRate).toFixed(2));
      noCov = firstConVal * secConvRate;
      conVal = firstConVal * secConvRate * 1.025;
      // conVal += Number(this.cashInfo.amount);
    }
    noCov = noCov ? noCov - this.walletInfo.amount : 0;
    let finalAmt = 0;
    if (this.cashInfo.amount) {
      this.wallet_pf = (Number(this.cashInfo.amount) * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.wallet_pf = Number(this.wallet_pf.toFixed(2));
      if (this.walletInfo && this.walletInfo.amount) {
        finalAmt = this.walletInfo.amount + Number(this.cashInfo.amount)
      } else {
        finalAmt = Number(this.cashInfo.amount);
      }
      this.finalVal = (finalAmt) + this.wallet_pf;
    }
    if (this.walletInfo.amount > this.finalVal) {
      this.dispSavedCards = false;
    } else {
      this.dispSavedCards = true;
    }
  }

  onCryptoAmtChange(value) {
    let reqAmt = this.nftTickets ? environment.ONE_USD : this.crypto_difference_amt ? this.crypto_difference_amt : environment.ONE_USD;
    if (value && Number(value) < Number(reqAmt)) {
      this.cryptoForm.patchValue({
        crypto_amount: reqAmt
      });
      this.toastr.error('Minimum required amount is ' + Number(reqAmt).toFixed(2) + this.cryptoToken);
    }
    this.cryptoPF()
  }

  redirectTo() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const streamId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Payment cancelled for ${streamId} - ${userId}`);
    const data = {
      actionType: "network",
      metaData: {
        title: `Payment cancelled for ${streamId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo?.organization_id || null,
      networkGroupId: this.streamInfo?.network_group_id || null,
      clickAction: `stream`
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    if (this.currentBlock == "Merchandise" || this.activeBlock == "Tips" || this.activeBlock == "Donations" || this.currentBlock == "Subscribe" || this.currentBlock == "PPV") {
      this.commonSubscribeService.formStatusSubject.next(true);
      this.dialogRef.close();
      return;
    }
    if (this.currentBlock == "Merch Market") {
      if(this.router.url.includes("/merchandise")){
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + '/merchandise/merch-list']);
      }
      else{
        this.router.navigateByUrl("network-market/market");
      }
      return;
    }
    
    if (Object.keys(this.route.snapshot.queryParams).length > 0)
    {
      this.router.navigate([`${this.commonSubscribeService.getBasePathFromUrl(this.router.url)}/event/` + this.route.snapshot.params.slug_name], { queryParams: { ref: this.route.snapshot.queryParams.ref } });
    }else{
      this.router.navigateByUrl(`${this.commonSubscribeService.getBasePathFromUrl(this.router.url)}/event/${this.route.snapshot.params.slug_name}`);
    }
      
  }

  mobileLinks() {
    let queryParams = this.route.snapshot.queryParams ? this.route.snapshot.queryParams : "";
    let cat = this.getParam('tag_category');
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Payment cancelled ${userId}`);
    const data = {
      actionType: "network",
      metaData: {
        title: "Payment cancelled",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo?.organization_id || null,
      networkGroupId: this.streamInfo?.network_group_id || null,
      clickAction: `stream`
    }
    this.commonSubscribeService.sendTriggeredEvent(data);

    if (this.currentBlock == "Merch Market") {
      this.mobileUrl = environment.CONSUMER_PORTAL + "network-market/market/cancel-payment";
      window.open(this.mobileUrl, "_blank");
      return;
    }
    if (this.currentBlock == "Tickets") {
      this.mobileUrl = environment.CONSUMER_PORTAL + this.route.snapshot.params.slug_name + '/cancel-payment';
    } else if ((this.activeBlock == "Tips" || this.activeBlock == "Donations" || this.currentBlock == "Merchandise") && !this.router.url.includes("/vod-tip-donation-payment/")) {
      this.mobileUrl = environment.CONSUMER_PORTAL + 'event/stream/' + queryParams['ticket_key'] + '?stage=' + queryParams["stream_id"] + '/cancel-payment';
    } else if ((this.router.url.includes("/vod-tip-donation-payment/") || this.currentBlock == "Subscribe" || this.currentBlock == "PPV") && !this.router.url.includes("/subscription-list")) {
      this.mobileUrl = environment.CONSUMER_PORTAL + this.streamInfo.channel_name + '/album/' + cat + '/' + this.streamInfo.slug + '/cancel-payment';
    } else if (this.router.url.includes("/subscription-list") && (this.route.snapshot.params.pName)) {
      this.mobileUrl = environment.CONSUMER_PORTAL + this.route.snapshot.params.pName + '/subscription-list/cancel-payment';
    }
    window.open(this.mobileUrl, "_blank");

  }

  loadStripe(currency, creator_currency) {
    let userLocale = 'en';
    const locale = ['ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'en-GB', 'es', 'es-419', 'et', 'fi', 'fr', 'fr-CA', 'he', 'hu', 'id', 'it', 'ja', 'lt', 'lv', 'ms', 'mt', 'nb', 'nl', 'pl', 'pt-BR', 'pt', 'ro', 'ru', 'sk', 'sl', 'sv', 'tr', 'th', 'zh', 'zh-HK', 'zh-TW'];
    let lang = this.commonSubscribeService.getLanguage();
    if (lang && locale.indexOf(lang) != -1) {
      userLocale = lang;
    }
    if ((currency != 'GBP' && creator_currency == 'USD') || currency == 'USD') {
      stripe = Stripe(environment.STRIPE_US_KEY, { locale: userLocale });
    } else {
      stripe = Stripe(environment.STRIPE_UK_KEY, { locale: userLocale });
    }
    if (this.userInfo.is_guest || !this.userInfo.id) {
      setTimeout(() => {
        this.initiateCardElement();
      }, 2000);
    }
  }

  initiateCardElement() {
    let zip = this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : this.getBillingValue && this.getBillingValue.zip ? this.getBillingValue.zip : '';
    // if (!elements) {
    elements = stripe?.elements()
    // }
    if (this.card) {
      this.card.destroy();
    }
    // if (!this.card) {
    // Giving a base style here, but most of the style is in scss file

    const cardStyle = {
      style: {
        base: {
          color: environment.themeColors.pentanary_bg_font_color1,
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '14px',
          '::placeholder': {
            color: environment.themeColors.pentanary_bg_font_color2,
          },
        },
        invalid: {
          color: this.currentTheme.reqMarker,
          iconColor: this.currentTheme.reqMarker,
        },
        hidePostalCode: !this.activeBlock ? true : false,
        value: !this.activeBlock ? { postalCode: zip } : {}
      }
    };

    this.card = elements.create('card', cardStyle);
    this.card?.mount(this.cardInfo.nativeElement);
    // this.card.addEventListener('change', this.cardHandler);
    this.card?.addEventListener('change', (event) => {
      //console.log(event);
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        this.cardError = null;
      }
      // if (event.value && event.value.postalCode && event.complete) {
      //   this.getTaxPercentage(event.value.postalCode);
      //   this.stripeZip = event.value.postalCode;
      // }
      if (event.complete) {
        this.validStripeForm = true;
      } else {
        this.validStripeForm = false;
      }
    });
    // document.querySelector('input.InputElement')['type'] = "password";
    // }
    this.card.update({ value: { postalCode: zip } });
  }

  showOverlay: boolean = false;
  timer = 120;
  toggleLoader(state) {
    if (state != 'none') {
      this.showOverlay = true;
      var counter = 120;
      var interval = setInterval(() => {
        counter--;
        if (counter <= 0) {
          clearInterval(interval);
          return;
        } else {
          this.timer = counter;
        }
      }, 1000);
    }
    if (state == 'none') {
      this.loader.stop();
    }
  }

  walletInfo: WalletInfo;
  // Organization for wallet-specific calls only: prefer the reliably-populated commonSubscribeService.orgId,
  // falling back to streamInfo.organization_id (which isn't always set depending on which page fed streamInfo).
  get walletOrgId() { return this.commonSubscribeService.orgId ?? this.streamInfo?.organization_id; }
  // Re-runs the balance-vs-total comparison used to decide whether the "add funds" panel
  // shows for Cash Wallet. Called both when the total amount changes and after the wallet
  // balance finishes loading, since either can arrive first and the decision must reflect
  // whichever value was stale when it was last made.
  private evaluateWalletSufficiency() {
    let firstConVal, conVal = 0;
    if ((this.walletInfo && this.walletInfo.amount <= 0 && this.walletInfo.currency == this.currency_for_totAmt) || !this.walletInfo || Object.keys(this.walletInfo).length == 0) {
      this.dispSavedCards = this.add_amt_to_wallet = true;
      this.minAmount = this.amt_without_pf;
      this.cashWalletForm.patchValue({
        amount: Number(this.amt_without_pf.toFixed(2))
      });
      this.wallet_pf = (Number(this.cashInfo.amount) * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.wallet_pf = Number(this.wallet_pf.toFixed(2));
      this.finalVal = this.finalVal + this.wallet_pf;
      return;
    }
    if (this.walletInfo.currency != this.currency_for_totAmt) {
      let firstConvRate, secConvRate;
      firstConvRate = this.rates[this.currency_for_totAmt];
      firstConVal = this.amt_without_pf / firstConvRate;
      secConvRate = this.rates[this.walletInfo.currency];
      this.convRate = (firstConvRate / secConvRate) * 1.025;
      this.convRate = Number((this.convRate).toFixed(2));
      // conVal = firstConVal * secConvRate;
      conVal = firstConVal * secConvRate * 1.025;
      this.finalVal = this.amt_without_pf = firstConVal * secConvRate * 1.025;
    } else if (this.walletInfo.currency == this.currency_for_totAmt) {
      this.finalVal = Number((this.totalAmount).toFixed(2));
    }
    this.finalVal = Number(this.finalVal.toFixed(2));
    let val = 0;
    if (this.walletInfo.amount >= this.finalVal) {
      this.wallet_pf = 0;
      this.dispSavedCards = this.add_amt_to_wallet = false;
      return;
    } else if (this.walletInfo.amount < this.finalVal) {
      this.minAmount = this.amt_without_pf - this.walletInfo.amount;
      this.minAmount = Number((this.minAmount).toFixed(2));
      this.minReqAmt = this.walletInfo && this.walletInfo.currency ? Number(this.rates[this.walletInfo.currency].toFixed(2)) : Number(this.rates[this.getCurrency]);
      val = this.minAmount < this.minReqAmt ? this.minReqAmt : this.minAmount;
      conVal = conVal ? conVal - this.walletInfo.amount : 0;
      this.cashWalletForm.patchValue({
        amount: Number(val.toFixed(2))
      });
      this.wallet_pf = (Number(conVal ? conVal : val) * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.wallet_pf = Number(this.wallet_pf.toFixed(2));
      this.dispSavedCards = this.add_amt_to_wallet = true;
      let amt = this.minAmount < this.minReqAmt ? this.minReqAmt - this.minAmount : 0;
      this.finalVal = this.finalVal + this.wallet_pf + amt;
    }
  }

  // ngOnInit calls getAvailBalance() more than once in a row for the same org; an identical
  // GET_WALLET already in flight sets the same wallet state, so it is not sent again. A different
  // org (e.g. once streamInfo is known) is still requested.
  private walletRequestOrgKey: string;
  getAvailBalance() {
    this.walletInfo = this.commonSubscribeService.walletByOrg[this.walletOrgId];
    const orgKey = String(this.walletOrgId || this.getParam('organization_id') || '');
    if (orgKey === this.walletRequestOrgKey) return;
    this.walletRequestOrgKey = orgKey;
    this.appPaymentService.getRequestWithParams(API.GET_WALLET, { organization_id: orgKey }).subscribe(response => {
      this.walletRequestOrgKey = null;
      if (response.status == 0) {
        this.walletInfo = response.wallet;
        this.commonSubscribeService.walletByOrg[this.walletOrgId] = response.wallet;
        this.commonSubscribeService.walletInfoSubject.next({ organizationId: this.walletOrgId, wallet: response.wallet });
        if (this.selectedTransaction == "wallet") {
          this.evaluateWalletSufficiency();
        }
      }
    }, error => {
      this.walletRequestOrgKey = null;
      this.toastr.error(error.error);
    });
  }

  isPayment = false;
  placeOrder() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Payment is completed for ${albumId} - ${userId}`);
    const data = {
      actionType: "event",
      metaData: {
        title: `Payment is completed for ${albumId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo?.organization_id || null,
      networkGroupId : this.streamInfo?.network_group_id || null,

      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(data);

    if (this.totalAmount > 0 && ((!this.addNewCard && !this.dispSavedCards) || ((this.walletInfo && this.walletInfo.amount > this.totalAmount) && !this.addNewCard && !this.dispSavedCards))) {
      this.isPayment = true;
      this.transactionInfo = {
        "mode": this.selectedTransaction,
        "transaction_amount": Number((this.amt_without_pf).toFixed(2))
      }
      this.commonSubscribeService.sendTransactionInfo(this.transactionInfo);
      return;
    }
    // else if(!this.totalAmount){
    //   this.toastr.error("Please enter amount")
    // }
    if (this.cashWalletForm.invalid) {
      this.toastr.error('Please enter amount');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.cashWalletForm);
      return;
    }
    let name;
    name = this.userInfo.user_display_name || this.userInfo.display_name;
    let code;
    if (this.selectedBillingAddress && this.selectedBillingAddress.line1) {
      let cc = this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : this.selectedBillingAddress.country;
      let country = COUNTRIES_LIST.filter(country => (country.alpha3code == cc || country.alpha2code == cc));
      code = country[0].alpha2code;
    }
    let billingAddress;
    billingAddress = {
      'line1': this.getBillingValue && this.getBillingValue.address1 ? this.getBillingValue.address1 : this.selectedBillingAddress && this.selectedBillingAddress.line1 ? this.selectedBillingAddress.line1 : "",
      'line2': this.getBillingValue && this.getBillingValue.address2 ? this.getBillingValue.address2 : this.selectedBillingAddress && this.selectedBillingAddress.line2 ? this.selectedBillingAddress.line2 : "",
      'city': this.getBillingValue && this.getBillingValue.city ? this.getBillingValue.city : this.selectedBillingAddress && this.selectedBillingAddress.city ? this.selectedBillingAddress.city : "",
      'state': this.getBillingValue && this.getBillingValue.state ? this.getBillingValue.state : this.selectedBillingAddress && this.selectedBillingAddress.state ? this.selectedBillingAddress.state : "",
      'country': this.getBillingValue && this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : code ? code : "",
      'postal_code': this.getBillingValue && this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
    }
    let cardInfo = {
      'card': this.card,
      'billing_details': {
        'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
        'address': this.activeBlock && (this.activeBlock == 'Tips' || this.activeBlock == 'Donations') ? billingAddress.postal_code : billingAddress
      }
    }
    if (((this.validStripeForm) || (this.selectedCard && this.selectedCard.id)) && this.totalAmount > 0) {
      this.isPayment = true;
      let walletCurrency = this.walletInfo && this.walletInfo.currency ? this.walletInfo.currency : this.getCurrency;
      let data = {
        "currency": walletCurrency,
        "creator_currency": walletCurrency == "GBP" ? "GBP" : "USD",
        "amount": Number(this.cashInfo.amount),
        "organization_id": this.walletOrgId
      }
      if (!this.router.url.includes('/stream'))
        this.loader.start();
      let url = API.GET_SECRET + '?NOLOADER';
      this.appPaymentService.postRequest(url, data).subscribe(result => {
        if (result['status'] == 0) {
          stripe.confirmCardPayment(result['client_secret'], {
            payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
          }).then((result) => {
            //console.log(result);
            if (!this.router.url.includes('/stream'))
              this.loader.stop();
            if (result.error) {
              this.showOverlay = false;
              this.commonSubscribeService.sendPaymentStatus(false);
              // Show error to your customer (e.g., insufficient funds)
              this.toastr.error(result.error.message);
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                try { fbq('track', 'StripePaymentSuccess'); } catch (e) { }
                let addWallet = {
                  "id": result['paymentIntent']['id'],
                  "amount": Number(this.cashInfo.amount),
                  "currency": this.walletInfo && this.walletInfo.currency ? this.walletInfo.currency : this.getCurrency,
                  "creator_currency": this.getCurrency == "GBP" ? "GBP" : "USD",
                  "payment_method": this.save_card && this.addNewCard && !this.userInfo.is_guest ? result.paymentIntent.payment_method : undefined,
                  "organization_id": this.walletOrgId
                }
                let url = API.ADD_WALLET;
                this.appPaymentService.postRequest(url, addWallet).subscribe(res => {
                  if (res['message'] == 'Success') {
                    this.toastr.success("Funds added successfully");
                    if (res['card_already_saved']) {
                      this.toastr.info("This card is already saved to your account");
                    }
                    this.transactionInfo = {
                      "mode": this.selectedTransaction,
                      "card": this.card ? this.card : undefined,
                      "stripe": stripe,
                      "paymentIntent": result['paymentIntent'],
                      "transaction_amount": Number(this.amt_without_pf.toFixed(2)),
                      "save_card": this.save_card && this.addNewCard && !this.userInfo.is_guest ? true : undefined,
                      "processing_fee": this.wallet_pf
                    }
                    this.commonSubscribeService.updateAvailBalSubject.next(true);
                    this.commonSubscribeService.sendTransactionInfo(this.transactionInfo);
                  } else {
                    try { fbq('track', 'StripePaymentFailed'); } catch (e) { }
                    this.showOverlay = false;
                    this.commonSubscribeService.updateAvailBalSubject.next(true);
                    this.commonSubscribeService.sendPaymentStatus(false);
                    this.toastr.error(res['message']);
                  }
                });
              }
            }
          });
        } else {
          this.isPayment = false;
          this.showOverlay = false;
          this.toastr.error(result["message"]);
          if (!this.router.url.includes('/stream'))
            this.loader.stop();
        }
      }, error => {
        this.toastr.error(error);
      });
    } else if (!this.cardError) {
      this.cardError = "Please fill all the fields";
    } else if (!this.addNewCard) {
      this.toastr.error("Please select card")
    }
    // else if(this.totalAmount > 0){
    //   this.toastr.error("Please enter amount")
    // }
  }

  completeOttPayment() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const streamId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Tips donated for stream ${streamId} - ${userId}`);
    console.log("Tips donated for stream", this.streamInfo);
    const data = {
      actionType: "network",
      metaData: {
        title: `Tips donated for stream ${streamId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo?.organization_id || null,
      networkGroupId : this.streamInfo?.network_group_id || null,

      clickAction: `stream`
    }
    this.commonSubscribeService.sendTriggeredEvent(data);

    if (((this.validStripeForm) || (this.selectedCard && this.selectedCard.id)) && this.totalAmount > 0) {
      this.isPayment = true;
      this.transactionInfo = {
        "mode": this.selectedTransaction,
        "card": this.card ? this.card : undefined,
        "stripe": stripe,
        "save_card": this.save_card && this.addNewCard && !this.userInfo.is_guest ? true : undefined
      }
      this.commonSubscribeService.sendTransactionInfo(this.transactionInfo);
    } else if (!this.cardError && this.addNewCard) {
      this.cardError = "Please fill all the fields";
    } else if (!this.addNewCard) {
      this.toastr.error("Please select card")
    }
    // else if(!this.totalAmount){
    //   this.toastr.error("Please enter amount")
    // }
  }

  async makePayment(from?) {
    // this.processingFee = (this.finalVal * (environment.processing_fee / 100)) + environment.fee_percentage;
    // this.finalVal += this.processingFee;
    this.finalVal = Number((this.amt_without_pf).toFixed(2))
    this.paymentType = this.activeBlock == "Tips" ? "performer_tip" : "charity_donation";
    let amount, finalAmount, name;
    name = this.userInfo.user_display_name || this.userInfo.display_name
    amount = finalAmount = this.finalVal;
    if (this.transactionInfo["card"] || from == 'card' || this.transactionInfo["mode"]) {
      let data: any = {
        amount: this.selectedTransaction == "crypto" ? this.crypto_amt : amount,
        finalAmount: this.selectedTransaction == "crypto" ? this.crypto_amt : finalAmount,
        currency: this.router.url.includes('community-tip-donation-payment') ? (this.getParam('currency') || 'usd').toLowerCase() : (this.transactionInfo.currency ? this.transactionInfo.currency : this.getCurrency?.toLowerCase() || 'gbp'),
        // Only when actually paying via wallet does this prefer walletOrgId (commonSubscribeService.orgId
        // fallback); card/crypto payments keep the original organization_id source unchanged.
        organization_id: this.selectedTransaction == 'wallet'
          ? (this.walletOrgId ?? this.streamInfo?.organization_id ?? Number(this.getParam('organization_id')))
          : (this.streamInfo?.organization_id || Number(this.getParam('organization_id'))),
        performer_id: this.router.url.includes('community-tip-donation-payment')? this.getParam('performer_id') :JSON.stringify(this.performerInfo?.id),
        stream_id: JSON.stringify(this.streamInfo?.id),
        paymentType: this.router.url.includes("community-tip-donation-payment") ? "community_tip": this.paymentType,
        payment_type: this.router.url.includes("community-tip-donation-payment") ? "community_tip": this.paymentType,
        response: null,
        transaction_id: '',
        name: name,
        network_group_id: this.streamInfo?.network_group_id || this.getParam('network_group_id') || ''
      };
      data['exchange_rate'] = this.minAmount;
      data['zip'] = this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "";
      if (this.paymentType == 'charity_donation' && this.org_info) {
        data['toName'] = this.org_info.organization_name;
        data['stream_id'] = this.streamInfo?.id;
        data['charity_id'] = this.org_info.id;
      } else if (this.paymentType == 'performer_tip' && this.performerInfo) {
        data['toName'] = this.performerInfo.performer_display_name;
      }
      if(this.streamInfo){
        this.streamInfo.event_id = this.streamInfo?.parent_streams_id == 0 ? this.streamInfo?.id : this.streamInfo?.parent_streams_id ;
      }

      data['guest_id'] = this.performerInfo.guest_id;
      data['invoice_id'] = this.invoice_id;
      data['tax_amount'] = this.taxAmount;
      data['tax_rate'] = this.taxPercentage;
      data['stream_id'] = this.streamInfo?.id;
      data['streamInfo'] = this.streamInfo ? this.streamInfo : null;
      data['country'] = this.selectedBillingAddress && this.selectedBillingAddress.country ? this.selectedBillingAddress.country : "";
      data['creator_currency'] = this.paymentType == 'charity_donation' ? this.streamInfo?.currency_type?.toLowerCase() : 'USD';
      let billingAddress;
      billingAddress = {
        'postal_code': this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
      }
      let cardInfo = {
        'card': this.card,
        'billing_details': {
          'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          'address': billingAddress
        }
      }
      this.toggleLoader('');
      data['guest_id'] = this.performerInfo.guest_id;
      data['fee_to_fan'] = 1;
      data['processing_fee_amount'] = this.selectedTransaction == "wallet" ? this.wallet_pf : this.processingFee;
      if (this.router.url.includes('community-tip-donation-payment')) {
        data['space_info'] = { id: this.getParam('space_id') };
        data['organization_id'] = data['organization_id'] || Number(this.getParam('organization_id'));
        data['toName'] = this.getParam('name') || '';
      }
      data['processing_fee_percentage'] = environment.processing_fee;
      data['processing_fee_fixed'] = environment.fee_percentage;
      if ((data['referral_code'] === undefined || data["referral_code"] === null) && localStorage.getItem('affiliateReferralCode')) {
        const rawCode = localStorage.getItem('affiliateReferralCode') || '';
        data['referral_code'] = rawCode.startsWith('"') ? JSON.parse(rawCode) : rawCode;
      }
      if (this.transactionInfo['mode'] == 'wallet' || this.transactionInfo["mode"] == 'crypto') {
        this.completeTransaction(data);
        return;
      }
      let url = API.GET_CLIENT_SECRET + "?NOLOADER";
      this.appPaymentService.postRequest(url, data).subscribe(result => {
        if (result['status'] == 0) {
          data.transaction_id = result['transaction_id'];
          // this.loader.start();
          stripe.confirmCardPayment(result['client_secret'], {
            payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
          }).then((result) => {
            //console.log(result);
            this.loader.stop();
            if (result.error) {
              this.isPayment = false;
              // Show error to your customer (e.g., insufficient funds)
              this.toastr.error(result.error.message);
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                data.response = result.paymentIntent;
                this.completeTransaction(data);

              }
            }
          });
        } else {
          this.isPayment = false;
          this.showOverlay = false;
          this.toastr.error(result.message)
          this.loader.stop();
        }
      }, error => {
        this.showOverlay = false;
      });
    } else if (!this.cardError) {
      this.cardError = "Please fill all the fields";
    } else if (this.savedCardsList.length > 0 && !this.addNewCard) {
      this.cardError = "Please select card";
    }
  }

  completeTransaction(data) {
    data.response = this.transactionInfo['paymentIntent'] ? this.transactionInfo['paymentIntent'] : data.response;
    data["payment_gateway"] = this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : undefined;
    data["transaction_amount"] = this.transactionInfo['transaction_amount'];
    data["save_card"] = this.transactionInfo['save_card'];
    data["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    if(this.router.url.includes("community-tip-donation-payment")){
      data.streamInfo = {
        stream_video_title : String(this.getParam('space_id'))
      }
    }
    let url = API.PAYMENT_SUCCESSS + "?NOLOADER";
    // Captured before the success branch's own `const data` (the tracking payload)
    // shadows this function's `data` parameter for that entire block.
    const completedTransactionAmount = data['transaction_amount'];
    this.appPaymentService.postRequest(url, data).subscribe(result => {
      this.showOverlay = false;
      if (result['message'] == 'Success') {
        this.toastr.success("Payment completed successfully");
        if (result['card_already_saved']) {
          this.toastr.info("This card is already saved to your account");
        }
        this.isPaymentSuccess = true;
        const data = {
          actionType: "purchase",
          metaData: {
            amount: this.transactionInfo.transaction_amount,
            title: `Payment completed successfully - ${this.transactionInfo.transaction_amount}`,
            timeStamp: new Date().toISOString()
          },
          organizationId: this.streamInfo?.organization_id || null,
          networkGroupId : this.streamInfo?.network_group_id || null,

          clickAction: "PAYMENT_SUCCESS",
          actionName: this.currentBlock ? this.currentBlock : this.activeBlock
        }
        this.commonSubscribeService.sendTriggeredEvent(data);
        // Donation-type payments (tips/charity) additionally count toward the
        // fan's own totalDonatedAmount stat, which reads a separate
        // DONATION_SUCCESS-tagged event rather than PAYMENT_SUCCESS.
        if (['community_tip', 'performer_tip', 'charity_donation'].includes(this.paymentType)) {
          this.commonSubscribeService.sendTriggeredEvent({
            actionType: "purchase",
            clickAction: "DONATION_SUCCESS",
            metaData: {
              amount: this.transactionInfo.transaction_amount,
              title: `Donation completed successfully`,
              timeStamp: new Date().toISOString()
            },
            organizationId: this.streamInfo?.organization_id || null,
            networkGroupId: this.streamInfo?.network_group_id || null,
          });
        }
        this.commonSubscribeService.updateAvailBal().subscribe(response => {
          if (response) {
            this.appPaymentService.getRequestWithParams(API.GET_WALLET, { organization_id: String(this.walletOrgId || '') }).subscribe(response => {
              if (response.status == 0) {
                this.walletInfo = response.wallet;
                this.commonSubscribeService.walletByOrg[this.walletOrgId] = response.wallet;
                this.commonSubscribeService.walletInfoSubject.next({ organizationId: this.walletOrgId, wallet: response.wallet });
              }
            }, error => {
              this.toastr.error(error.error);
            });
          }
        });
        this.commonSubscribeService.tipsDonationsPaymentSuccessful.next('success'); // to close tips and donation popup if successful
      } else {
        this.isPayment = false;
        this.toastr.error(result['message']);
      }
    });
  }

  getParam(param) {
    try {
      let url = decodeURIComponent(location.href).split("?");
      let queryParams = url[1].split("&");
      let params = {};
      if (queryParams && queryParams.length > 0) {
        queryParams.forEach(p => {
          let p1 = p.split("=");
          params[p1[0]] = p1[1];
        });
      }
      return params[param];
    } catch (e) {
      console.log(e);
      return this.route.snapshot.queryParamMap.get(param);
    }
  }

  getUserInfo(callback) {
    let id = this.getParam('user_id')
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        // "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "user_id": id,
        "organization_id": this.streamInfo?.organization_id || Number(this.getParam('organization_id'))
      }
    }
    // this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
      // this.loader.stop();
      if (response.data.user) {
        let token = this.getParam('token');
        if (token) {
          response.data.user.access_token = token
        } else {
          response.data.user.access_token = response.data.user.session_token;
        }
        this.userInfo = this.commonSubscribeService.userInfo = response.data.user;
        this.commonSubscribeService.sendUserInfo(this.userInfo);
      }
      callback();
    }).catch(error => {
      // this.loader.stop();
    });
  }

  getStreamInfo() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "stream_id": this.streamId,
        "userid": this.userInfo.id,
      }
    }
    this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
      this.loader.stop();
      this.streamInfo = response.data.Data.stream_info;
      console.log("Stream Info:", this.streamInfo);
      let cat = this.getParam('tag_category');
      
          this.channelUrl = environment.CONSUMER_PORTAL + this.streamInfo.channel_name + '/album/' + cat + '/' + this.streamInfo.slug;
      this.commonSubscribeService.sendSlugData(this.streamInfo);
    }).catch(error => {
      this.loader.stop();
    });
  }
  metamaskinstalled: boolean = false;
  add_amt_to_crypto_wallet = false;

  completeCryptoPayment() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const streamId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Tips are donated in the stream ${streamId} - ${userId}`)
    const u_payload = {
        actionType: "network",
        metaData: {
          title: `Tips are donated in the stream ${streamId}`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo.organization_id || null,
        networkGroupId : this.streamInfo?.network_group_id || null,

        clickAction: `stream`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);
    if (this.add_amt_to_crypto_wallet || this.newCardForCrypto) {
      this.addFundsToCrypto();
    }
    if (this.totalAmount > 0 && ((!this.newCardForCrypto && !this.add_amt_to_crypto_wallet) || ((this.available_balance > this.totalAmount) && !this.newCardForCrypto && !this.add_amt_to_crypto_wallet))) {
      this.transferCrypto();
      return;
    }
  }

  transferCrypto() {
    if (this.walletID) {
      let erc20contract = this.web3service.getContract('ERC20');
      this.web3service.checkAndInstantiateWeb3().then(isweb3 => {
        if (isweb3 === 'connected') {
          this.loader.start();
          let tokens = this.commonSubscribeService.convertToCryptoAmount(this.amt_without_pf, this.USD_Rates[this.currency_for_totAmt]);
          let final_amount = this.web3service.convertPriceToEther(tokens);
          erc20contract.methods.transfer(environment.owner_cryptoWallet, final_amount).send({ from: this.walletID }).once('receipt', (receipt) => {
            // let result = JSON.stringify(receipt);
            // console.log(JSON.stringify(receipt),"receipt")
            if (receipt) {
              // this.redirectTo();
              this.loader.stop();
              // console.log(receipt.status)
              if (receipt.status == true) {
                this.transactionInfo = {
                  "mode": this.selectedTransaction,
                  "currency": environment.clientDetails.crypto_token,
                  "crypto_wallet_id": this.walletID,
                  "transaction_amount": Number(tokens),
                }
                this.commonSubscribeService.sendTransactionInfo(this.transactionInfo);
                this.commonSubscribeService.getAccountBalance(this.walletID);
                this.toastr.success("Payment Completed Successfully.")
                this.loader.stop()
              }
              else {
                this.toastr.error("Payment failed.");
                this.loader.stop();
              }
            }
          }).catch(e => {
            console.log("error", e);
            if (e.message.includes('User denied transaction')) {
              this.loader.stop();
              this.toastr.error('Transaction Rejected.');
            }
          })
          // })
        }
      })
    }

    else {
      this.connectWallet();
    }
  }

  async addFundsToCrypto() {
    if (this.cryptoForm.invalid) {
      this.toastr.error('Please enter amount');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.cryptoForm);
      return;
    }
    if (this.nftTickets) {
      await this.web3service.getchainId().then((chainid) => {
        if (chainid != this.nftDetails.blockchain) {
          let chaindata = this.nftDetails.blockchain == 'Polygon' ? 'Polygon' : 'Sepolia';
          localStorage.setItem('networkId', chaindata);
          this.web3service.changeNetwork(chaindata).then(data => {
            return
          })
        }
      })
    }
    let name;
    name = this.userInfo.user_display_name || this.userInfo.display_name;
    let code;
    if (this.selectedBillingAddress && this.selectedBillingAddress.line1) {
      let cc = this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : this.selectedBillingAddress ? this.selectedBillingAddress : this.card.address_zip;
      let country = COUNTRIES_LIST.filter(country => (country.alpha3code == cc || country.alpha2code == cc));
      code = country[0]?.alpha2code;
    }
    let billingAddress;
    billingAddress = {
      'line1': this.getBillingValue && this.getBillingValue.address1 ? this.getBillingValue.address1 : this.selectedBillingAddress && this.selectedBillingAddress.line1 ? this.selectedBillingAddress.line1 : "",
      'line2': this.getBillingValue && this.getBillingValue.address2 ? this.getBillingValue.address2 : this.selectedBillingAddress && this.selectedBillingAddress.line2 ? this.selectedBillingAddress.line2 : "",
      'city': this.getBillingValue && this.getBillingValue.city ? this.getBillingValue.city : this.selectedBillingAddress && this.selectedBillingAddress.city ? this.selectedBillingAddress.city : "",
      'state': this.getBillingValue && this.getBillingValue.state ? this.getBillingValue.state : this.selectedBillingAddress && this.selectedBillingAddress.state ? this.selectedBillingAddress.state : "",
      'country': this.getBillingValue && this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : code ? code : "",
      'postal_code': this.getBillingValue && this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
    }
    let cardInfo = {
      'card': this.card,
      'billing_details': {
        'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
        'address': this.card && this.nftTickets ? { 'postal_code': this.card.address_zip } : Object.keys(billingAddress).length > 0 ? billingAddress : ''
      }
    }
    if (((this.validStripeForm) || (this.selectedCard && this.selectedCard.id)) && (this.totalAmount > 0 || this.nftTicketPrice)) {
      this.isPayment = true;
      let data = {
        "currency": this.getCurrency,
        "creator_currency": this.getCurrency == "GBP" ? "GBP" : this.streamInfo?.currency_type,
        "amount": Number((this.cryptoInfo.crypto_amount / environment.ONE_USD) * this.USD_Rates[this.getCurrency]) + this.crypto_pf,
        "organization_id": this.walletOrgId
      }
      if (!this.router.url.includes('/stream'))
        this.loader.start();
      let url = API.GET_SECRET + '?NOLOADER';
      this.appPaymentService.postRequest(url, data).subscribe(result => {
        if (result['status'] == 0) {
          stripe.confirmCardPayment(result['client_secret'], {
            payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
          }).then((result) => {
            console.log(result);
            if (!this.router.url.includes('/stream'))
              this.loader.stop();
            if (result.error) {
              this.showOverlay = false;
              this.commonSubscribeService.sendPaymentStatus(false);
              // Show error to your customer (e.g., insufficient funds)
              this.toastr.error(result.error.message);
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                try { fbq('track', 'StripePaymentSuccess'); } catch (e) { }
                let addWallet = {
                  "id": result['paymentIntent']['id'],
                  "amount": Number(this.cashInfo.amount),
                  "currency": this.getCurrency,
                  "creator_currency": this.getCurrency == "GBP" ? "GBP" : this.streamInfo?.currency_type,
                  "payment_method": this.save_card && this.addNewCard && !this.userInfo.is_guest ? result.paymentIntent.payment_method : undefined,
                  "organization_id": this.walletOrgId
                }
                let url = API.ADD_WALLET;
                this.appPaymentService.postRequest(url, addWallet).subscribe(res => {
                  if (res['message'] == 'Success') {
                    this.buyAreveaToken(result['paymentIntent']);
                  } else {
                    try { fbq('track', 'StripePaymentFailed'); } catch (e) { }
                    this.showOverlay = false;
                    this.commonSubscribeService.updateAvailBal().subscribe(response => {
                      if (response) {
                        this.appPaymentService.getRequestWithParams(API.GET_WALLET, { organization_id: String(this.walletOrgId || '') }).subscribe(response => {
                          if (response.status == 0) {
                            this.walletInfo = response.wallet;
                            this.commonSubscribeService.walletByOrg[this.walletOrgId] = response.wallet;
                            this.commonSubscribeService.walletInfoSubject.next({ organizationId: this.walletOrgId, wallet: response.wallet });
                          }
                        }, error => {
                          this.toastr.error(error.error);
                        });
                      }
                    });
                    this.commonSubscribeService.sendPaymentStatus(false);
                    this.toastr.error(res['message']);
                  }
                });
              }
            }
          });
        } else {
          this.isPayment = false;
          this.showOverlay = false;
          this.toastr.error(result["message"]);
          if (!this.router.url.includes('/stream'))
            this.loader.stop();
        }
      }, error => {
        this.toastr.error(error);
      });
    } else if (!this.cardError) {
      this.cardError = "Please fill all the fields";
    } else if (!this.addNewCard) {
      this.toastr.error("Please select card")
    }
  }


  buyAreveaToken(paymentIntent) {
    this.amount = this.cryptoInfo.crypto_amount
    if (this.walletID) {
      this.web3service.checkAndInstantiateWeb3().then((isweb3: any) => {
        if (isweb3 === 'connected') {
          this.loader.start();

          let amount = this.web3service.convertPriceToEther(this.amount);

          let erc20contract = this.web3service.getContract('ERC20');
          // console.log('test', erc20contract.methods)
          let marketplacecontract = this.web3service.getContract('MarketPlace');

          marketplacecontract.methods.buyToken(erc20contract._address, this.walletID, amount)
            .send({ from: this.walletID })
            .once('receipt', (receipt) => {
              this.loader.stop();
              console.log("Rceipt of purchace of Arevea Token", receipt);
              if (receipt.status == true || receipt.status == "1n") {
                this.commonSubscribeService.getAccountBalance(this.walletID);
                this.transactionInfo = {
                  "mode": this.selectedTransaction,
                  "card": this.card ? this.card : undefined,
                  "stripe": stripe,
                  "paymentIntent": paymentIntent,
                  "transaction_amount": Number(this.amt_without_pf.toFixed(2)),
                  "save_card": this.save_card && this.addNewCard && !this.userInfo.is_guest ? true : undefined,
                  "processing_fee": this.crypto_pf
                }
                // this.commonSubscribeService.updateAvailBalSubject.next(true);
                // this.commonSubscribeService.sendTransactionInfo(this.transactionInfo);
                this.toastr.success("Funds added Successfully.");
                this.commonSubscribeService.getAccountBalance(this.walletID);
                this.add_amt_to_crypto_wallet = false;
                this.isPayment = true;
                this.getvalue('', 'crypto')
              }
              else {
                this.toastr.error("Failed to Add Funds.");
              }
            })
            .catch((e) => {
              console.log("error", e);
              if (e.message.includes('User denied transaction')) {
                this.loader.stop();
                this.toastr.error('Transaction Rejected.');
              }
            })
        }
      })
    }
    else {
      this.connectWallet();
    }
  }

  convertTokens() {
    const dialogRef = this.dialog.open(ConvertTokensComponent, {
      width: '437px',
      data: {
        selectedToken: this.selectedToken,
        targetToken: this.selectedToken === 'GFL' ? 'KO+' : 'GFL',
        tokensCount: this.cryptoForm.get('crypto_amount').value,
        settingsData: this.settingsData
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.onTokenSelect(result.selectedToken);
      }
    });
  }

  ngOnDestroy() {
    this.card = '';
    elements = '';
    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe();
    }
    if (this.addressListInfoSubscr) {
      this.addressListInfoSubscr.unsubscribe();
    }
    if (this.savedCardsListSubscr) {
      this.savedCardsListSubscr.unsubscribe();
    }
    if (this.streamInfoSubscr) {
      this.streamInfoSubscr.unsubscribe();
    }
    if (this.formsValSubscr) {
      this.formsValSubscr.unsubscribe();
    }
    if (this.currencyInfoSubscription) {
      this.currencyInfoSubscription.unsubscribe();
    }
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
    if (this.totalAmtSubscr) {
      this.totalAmtSubscr.unsubscribe();
    }
    if (this.billingInfoSubscr) {
      this.billingInfoSubscr.unsubscribe();
    }
    if (this.userDetailSubscr) {
      this.userDetailSubscr.unsubscribe();
    }
    if (this.performerInfoSubscr) {
      this.performerInfoSubscr.unsubscribe();
    }
    if (this.transactionInfoSubscr) {
      this.transactionInfoSubscr.unsubscribe();
    }
    if (this.walletInfoSubscr) {
      this.walletInfoSubscr.unsubscribe();
    }
    if (this.paymentBtnSubscr) {
      this.paymentBtnSubscr.unsubscribe();
    }
    if (this.cryptoAmount) {
      this.cryptoAmount.unsubscribe();
    }
    if (this.accounchanged) {
      this.accounchanged.unsubscribe();
    }
    this.commonSubscribeService.tipsDonationsPaymentSuccessful.next(null);
  }

}